export function formatDateForInput(date) {
    if (!date) return "";
    const d = new Date(date);
    if (isNaN(d.getTime())) return "";

    const pad = (num) => num.toString().padStart(2, '0');

    return (
        d.getFullYear() +
        "-" +
        pad(d.getMonth() + 1) +
        "-" +
        pad(d.getDate()) +
        "T" +
        pad(d.getHours()) +
        ":" +
        pad(d.getMinutes())
    );
}

export function formatDateForTitle(date) {
    if (!date) return "";
    const d = new Date(date);
    if (isNaN(d.getTime())) return "";

    const pad = (num) => num.toString().padStart(2, '0');

    return (
        pad(d.getDate()) +
        "-" +
        pad(d.getMonth() + 1) +
        "-" +
        d.getFullYear() +
        " - " +
        pad(d.getHours()) +
        ":" +
        pad(d.getMinutes())
    );
}

export function getFormatForTimeValue(value) {
    let formattedValue = value;
    if (!(value instanceof Number)) {
        formattedValue = parseInt(value);
    }

    if (formattedValue < 10) {
        return `0${formattedValue}`;
    }

    return formattedValue;
}

export function getMillisecondsFormat(value) {
    let formattedValue = value;
    if (!(value instanceof Number)) {
        formattedValue = parseInt(value);
    }

    if (formattedValue < 10) {
        return `${formattedValue}00`;
    }

    if (formattedValue < 100) {
        return `${formattedValue}0`;
    }

    return formattedValue;
}